import React from 'react';
import "./Pricelist.scss";
import { Article } from '../../components/Article/Article';

export const Pricelist = ()=>{
  
  return (
    <section className="Pricelist wall">
      <Article src="pricelist" className="block"/>
      <Article src="pricelist.footer" className="block"/>
    </section>
  );
}

{/* <div className="block">
<h1>CENA A MÍSTO PŮSOBENÍ</h1>
<article>
  <p>
    Obvykle celá procedura trvá <strong>60 - 90 minut</strong>. Dle vašeho přání může být delší.
  </p>
  <p>
    Setkání probíhá v Praze, přesné místo dle domluvy.
  </p>
  <p>
    Cena dohodou
  </p>
  <p className="foot">
    <strong>Ráda vám budu nápomocná k tomu, abyste se cítili lépe, šťastněji a vyrovnaněji za pomoci mého dotyku.</strong>
  </p>
</article>
</div> */}

export default Pricelist;
